import { render, staticRenderFns } from "./serviceFeeLists.vue?vue&type=template&id=bd699662&scoped=true&"
import script from "./serviceFeeLists.vue?vue&type=script&lang=js&"
export * from "./serviceFeeLists.vue?vue&type=script&lang=js&"
import style0 from "./serviceFeeLists.vue?vue&type=style&index=0&id=bd699662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd699662",
  null
  
)

export default component.exports